import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import PersonalinfotypeList from './personalinfotype-list.component';
import PersonalinfotypeCreate from './personalinfotype-create.component';
import PersonalinfotypeView from './personalinfotype-view.component';
import PersonalinfotypeEdit from './personalinfotype-edit.component';
import PersonalinfotypeCopy from './personalinfotype-copy.component';
import PersonalinfotypeDelete from './personalinfotype-delete.component';

interface Props {
  root?: string;
}

export const PersonalinfotypeRouteCustomer: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={`${props.root||''}/customertype/create`} render={(params) => <PersonalinfotypeCreate {...params} caption='Create Customer Type' personalinfotypeType='customer' />} />    
      <Route path={`${props.root||''}/customertype/view`} render={(params) => <PersonalinfotypeView {...params} caption='View Customer Type' personalinfotypeType='customer' />} />        
      <Route path={`${props.root||''}/customertype/edit`} render={(params) => <PersonalinfotypeEdit {...params} caption='Edit Customer Type' personalinfotypeType='customer' />} />        
      <Route path={`${props.root||''}/customertype/copy`} render={(params) => <PersonalinfotypeCopy {...params} caption='Duplicate Customer Type' personalinfotypeType='customer' />} />     
      <Route path={`${props.root||''}/customertype/delete`} render={(params) => <PersonalinfotypeDelete {...params} caption='Delete Customer Type' personalinfotypeType='customer'/>} />        
      <Route path={(props.root||'') + '/customertype'} render={(params) => <PersonalinfotypeList {...params} root={props.root} caption='Customer Type' personalinfotypeType='customer' />} /> 
    </Switch>
  );
}
